/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useAppKontoContext } from "../../../../Basis/Components/AppKontoContext";
import { useAppSnackbar } from "../../../../Basis/Components/AppSnackbarContext";
import IAppSnackbar from "../../../../Basis/Components/AppSnackbarContext/IAppSnackbar";
import ViewModel from "../../../../Basis/ViewModels/ViewModel";
import AendereEigenesPasswort, { AendereEigenesPasswortInput } from "../../Commands/AendereEigenesPasswort";
import { Konto } from "../../Queries/LadeEigenesKonto";
import AendereEigenesPasswortDialogProps from "./AendereEigenesPasswortDialogProps";
import AendereEigenesPasswortDialogState, { createInitialState } from "./AendereEigenesPasswortDialogState";

export default class AendereEigenesPasswortModel extends ViewModel<AendereEigenesPasswortDialogState> {
    private readonly _konto: Konto | undefined;
    private readonly _snackbar: IAppSnackbar;
    private readonly _aendereEigenesPasswort: AendereEigenesPasswort;

    public constructor(private readonly _props: AendereEigenesPasswortDialogProps) {
        super({
            initialState: createInitialState(),
        });
        this._konto = useAppKontoContext().konto;
        this._snackbar = useAppSnackbar();
        this._aendereEigenesPasswort = new AendereEigenesPasswort();
    }

    public get isOpen(): boolean {
        return this._props.isOpen;
    }

    public readonly aendereEigenesPasswort = () => {
        this.executeCommandAsync(() =>
            this._aendereEigenesPasswort.execute(this.getExecuteInput()).then(() => {
                this.hideCoffeeMug();
                this.reset();
                this._props.onEigenesPasswortGeaendert();
            }));
    };

    public readonly abbrechen = () => {
        this.reset();
        this._props.onAendereEigenesPasswortAbgebrochen();
        this._snackbar.clear();
    };

    private getExecuteInput(): AendereEigenesPasswortInput {
        return {
            kontoId: this._konto?.kontoId ?? "",
            aktuellesPasswort: this.state.aktuellesPasswort ?? "",
            neuesPasswort: this.state.neuesPasswort ?? "",
            neuesPasswortWiederholung: this.state.neuesPasswortWiederholung ?? "",
        };
    }
}
